module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 new-global-item"
  }, [_c('label', {
    attrs: {
      "for": "item-name"
    }
  }, [_vm._v("Item Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globalItem.name),
      expression: "globalItem.name"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "name": "item-name"
    },
    domProps: {
      "value": (_vm.globalItem.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.globalItem.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "item-category"
    }
  }, [_vm._v("Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globalItem.category),
      expression: "globalItem.category"
    }],
    attrs: {
      "type": "text",
      "name": "item-category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.globalItem.category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.globalCategories), function(globalCategory) {
    return _c('option', {
      domProps: {
        "value": globalCategory['.value']
      }
    }, [_vm._v(_vm._s(globalCategory['.value']))])
  })), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-button--raised",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveGlobalListItem()
      }
    }
  }, [_vm._v("Add Item")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 header"
  }, [_c('span', {
    staticClass: "back-link material-icons",
    attrs: {
      "onclick": "window.history.back()"
    }
  }, [_vm._v("chevron_left")]), _vm._v(" "), _c('h1', [_vm._v("Add Item")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-218d60fd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewGlobalListItem.vue
// module id = 130
// module chunks = 0